import { useEffect, useState, type ReactNode } from 'react';
import { apiRequest } from '../../api/client.js';
import { useAuth } from '../../auth/AuthProvider.js';
import { useTranslation } from '../../../../shared/i18n/index.js';

interface PolicyRow {
  readonly policyId: string;
  readonly policyCode: string;
  readonly policyName: string;
  readonly policyCategory: string;
  readonly currentVersion: number;
}

export function M21PolicyRepositoryPage(): ReactNode {
  const { t } = useTranslation();
  const { token } = useAuth();
  const [rows, setRows] = useState<PolicyRow[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let alive = true;
    apiRequest<{ data: PolicyRow[] }>('/v1/policies', { token })
      .then((r) => { if (alive) setRows(r.data); })
      .catch((e) => { if (alive) setError((e as Error).message); });
    return () => { alive = false; };
  }, [token]);

  if (error) return <p role="alert">{error}</p>;
  if (!rows) return <p>{t('m21.policy.loading')}</p>;
  return (
    <main aria-label="policy-repository">
      <h1>{t('m21.policy.title')}</h1>
      <table aria-label="policies-table">
        <thead><tr><th>{t('m21.policy.colCode')}</th><th>{t('m21.policy.colName')}</th><th>{t('m21.policy.colCategory')}</th><th>{t('m21.policy.colVersion')}</th></tr></thead>
        <tbody>
          {rows.map((p) => (
            <tr key={p.policyId}>
              <td>{p.policyCode}</td>
              <td>{p.policyName}</td>
              <td>{p.policyCategory}</td>
              <td>{p.currentVersion}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </main>
  );
}
